class NtAutocompleteAddress {
    constructor(
        loaderService,
        googleMapsPlaces
    ) {
        this.loader = loaderService;
        this.googleMapsPlaces = googleMapsPlaces;
        this.inputName = "street_address";
        this.label = this.label  || gettext("Почтовый адрес");
    }

    search (query) {
        const text = query.trim();
        return this.googleMapsPlaces.findAddresses(text);
    }

    selectedItem(item) {
        if(item) {
            document.activeElement.blur();
            this.googleMapsPlaces
                .getPlaceDetails(item.place_id)
                .then((place) => {
                    if(this.onChange) {
                        this.onChange({
                            place
                        });
                    }
                });
        }
    }
}


commons.component('ntAutocompleteAddress', {
    templateUrl: '/static/scripts/modules/Commons/views/components/nt-autocomplete.html',
    controller: NtAutocompleteAddress,
    controllerAs: 'vm',
    bindings: {
        isDisabled: '=',
        required: '<?',
        name: '=',
        onChange: '&',
        label: '@?'
    }
});